<template>
  <div class="author">
    <div class="hero-section">
      <div class="header container">
        <div class="content-header col-6">
          <div class="info-author">
            <img
              :src="`${$config.imagesUrl}/team/thumb@360_${author.image}`"
              class="image"
            >
            <div class="title-subtitle">
              <div class="name-author">
                <h1 class="h3">
                  {{ author.name }}
                </h1>
                <a
                  v-if="author.linkedin"
                  class="link"
                  :href="author.linkedin"
                  target="_blank"
                  rel="noopener"
                >
                  <IconLinkedin />
                </a>
              </div>
              <p class="subtitle blog-post-title-6">
                Blog author at 365 Data Science
              </p>
            </div>
          </div>
          <p class="description body-2">
            <span v-html=" author.authorDescription" />
          </p>
        </div>
      </div>
    </div>
    <div class="articles-authors container">
      <h2 class="h3 mobile">
        Articles from This Author
      </h2>
      <div class="articles row">
        <ArticleCard
          v-for="(article, i) in articles"
          :key="i"
          :article="article"
          class="col col-4"
        />
      </div>
      <Pagination
        v-if="count > limit"
        :page="+currentPage || 1"
        :total="count"
        :per-page="+limit"
        align="center"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@itbpbg/lms-components/src/components/Pagination';
import IconLinkedin from '@itbpbg/lms-components/src/assets/svg/icon-site-linkedin.svg?vue-component';
import ArticleCard from './ArticleCard';

export default {
  components: {
    Pagination,
    ArticleCard,
    IconLinkedin,
  },
  props: {
    author: { type: Object, required: true },
    posts: { type: Object, default: () => ({}), required: true },
  },
  data() {
    return {
      articles: this.posts.posts || [],
      count: this.posts.count || 0,
      limit: 6,
      currentPage: +this.$route.query.page || 1,
    };
  },
  watch: {
    async $route(v) {
      const page = +v.query.page || 1;
      this.currentPage = page;
      await this.fetchPosts();
    },
  },
  methods: {
    async fetchPosts() {
      const { posts = [], count = 0, limit = 0 } = await this.$axios
        .$get(
          `/blog/posts?page=${this.currentPage}&filter[authors][]=${this.author.id}&limit=${this.limit}`,
        )
        .catch(() => {});
      this.articles = posts;
      this.count = count;
      this.limit = limit;
    },
  },
};
</script>

<style lang="scss" scoped>
.author {
  .hero-section {
    position: relative;
    background: var(--main-dark);
    color: var(--main-light);
    display: flex;
    align-items: center;
    height: 650px;
    // padding: 189px 719px 117px 151px;

    &:before {
      content: "";
      background: linear-gradient(253.23deg, rgba(0, 164, 178, 0.2) 0%, rgba(0, 164, 178, 0.05) 44.75%, rgba(0, 164, 178, 0) 94.77%);
      transform: matrix(-1, 0, 0, 1, 0, 0);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
    }

    .image {
      height: 160px;
      width: 160px;
      border-radius: 50%;
      object-fit: cover;
      object-position: center;
    }

    .info-author {
      display: flex;
      align-items: center;

      .title-subtitle {
        margin-left: 46px;

        .name-author {
          display: flex;
          align-items: center;
          margin-bottom: var(--spacing-16);

          .h3 {
            margin: 0;
            margin-right: 10px;
          }

          a {
            display: flex;
            z-index: 1;
          }
        }
      }
    }

    .subtitle {
      color: var(--accent);
      margin-top: var(--spacing-12);
      margin-bottom: 0;
    }

    svg {
      width: 24px;
      height: 24px;
      background: #0A7ED4;
      padding: 2px;
      margin-left: var(--spacing-4);
      border-radius: 2px;
      vertical-align: top;
    }

    a {
      display: inline-block;
    }

    .description {
      color: var(--main-dark-shade-4);
      margin-top: var(--spacing-40);
      margin-bottom: 0;
    }
  }

  .articles-authors {
    padding-top: var(--spacing-120);
    padding-bottom: var(--spacing-120);

    .pagination {
      margin-top: var(--spacing-100);
    }
  }
}

@include bp($bp-laptop) {
  .author .hero-section .image {
    width: 140px;
    height: 140px;
  }
}

@include bp($bp-phone) {
  .author {
    .hero-section {
      height: 100%;

      .header {
        padding-top: 148px;
        padding-bottom: var(--spacing-lg);
      }

      .info-author {
        display: block;

        .image {
          height: 140px;
          width: 140px;
          margin-bottom: var(--spacing-48);
        }

        .title-subtitle {
          margin-left: 0;
        }
      }

      .description {
        span {
          font-size: 16px;
        }
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .articles-authors {
      padding-top: var(--spacing-80);

      .mobile {
        margin-bottom: var(--spacing-40);
        font-size: 24px;
      }
    }
  }
}
</style>
